export default [
    {
        path: '/website-highlight',
        props: true,
        component: () => import('@/views/WebsiteHighlight'),
    },
];
